import { queryOptions } from '@tanstack/react-query';
import getConfig from 'next/config';

import { donedealServicesGateway } from '../../../api/api-utils/commonApiUtils';
import { showroomFiltersSchema } from './showroomFilters.schema';

export const showroomFilters = (section: string, dealer: string) => {
  const {
    publicRuntimeConfig: { API_LISTINGS_TIMEOUT },
  } = getConfig();

  return queryOptions({
    queryKey: ['getDealershipFilters', section, dealer],
    queryFn: getShowroomFilters(section, dealer, API_LISTINGS_TIMEOUT),
    staleTime: Infinity,
  });
};

const getShowroomFilters =
  (section: string, dealer: string, timeout: number) => async () => {
    const isDealerId = /^\d+$/.test(dealer);

    const response = await donedealServicesGateway.get(
      `/ddapi/v1/search/showroom/filters/${section}`,
      {
        params: isDealerId ? { dealerId: dealer } : { dealerSeoName: dealer },
        timeout,
      },
    );

    return showroomFiltersSchema.parse(response.data);
  };
